export enum CouponMutationTypes {
  SET_COUPON_SUCCESS = 'SET_COUPON_SUCCESS',
  SET_COUPON_ERROR = 'SET_COUPON_ERROR'
}
